import { loadingController, toastController } from "@ionic/core";
import {
  IonAlert,
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonRow,
  withIonLifeCycle,
} from "@ionic/react";
import React from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import LimeAPI from "../classes/LimeAPI";
import Header from "../components/Header/Header";
import "../components/QualityDocuments/quality-documents.css";
import QualityDocumentSectionFive from "../components/QualityDocuments/QualityDocumentSectionFive";
import QualityDocumentSectionFour from "../components/QualityDocuments/QualityDocumentSectionFour";
import QualityDocumentSectionOne from "../components/QualityDocuments/QualityDocumentSectionOne";
import QualityDocumentSectionThree from "../components/QualityDocuments/QualityDocumentSectionThree";
import QualityDocumentSectionTwo from "../components/QualityDocuments/QualityDocumentSectionTwo";
import QualityDocumentsHeader from "../components/QualityDocuments/QualityDocumentsHeader";
import { logEvent } from "../helpers/analytics";
import { setProjectStatus } from "../helpers/project";
import { currentUserIsAdmin } from "../helpers/roles";
import {
  clearQualityDocumentDraft,
  getCurrentVersion,
  loadQualityDocumentDraft,
  mapFormDataToV4,
  newQualityDocumentState,
  saveQualityDocumentDraft,
} from "../helpers/states";
import { fetchProjectIfNeeded } from "../helpers/ensureRouteHierarchy";
import { validateForm } from "../helpers/validation";
import store, { actions, RootState } from "../store/index";
import { QualityDocumentsInterface } from "../store/qualityDocuments/types";
import { APIUserInterface } from "../store/user/actions";

class PageNewQualityDocument extends React.Component<any, any> {
  abortController = new AbortController();
  supplierAbortController = new AbortController();
  saveDraftTimeout: NodeJS.Timeout | null = null;

  constructor(props: any) {
    super(props);

    this.state = {
      ...newQualityDocumentState(),
      showLegacyRedirectAlert: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onAddPicture = this.onAddPicture.bind(this);
    this.removePicture = this.removePicture.bind(this);
    this.createQualityDocument = this.createQualityDocument.bind(this);
  }

  async ionViewWillEnter() {
    await fetchProjectIfNeeded(
      this.props.match.params.id,
      this.abortController.signal,
      this.props.setCurrentProject,
    );
    const { user } = this.props;
    const project = store.getState().currentProject;

    // Always reset alert state when entering the view
    // This is critical - without this, the alert won't show again after navigation
    this.setState({ showLegacyRedirectAlert: false });

    this.getSuppliers();

    // Try to load draft data from localStorage
    const draftData = loadQualityDocumentDraft(String(project.id));

    // Start with fresh initial state
    let mergedFormData: any = { ...newQualityDocumentState().formData };

    if (draftData) {
      // Merge draft data with initial state
      for (const key in draftData) {
        if (draftData.hasOwnProperty(key) && mergedFormData[key]) {
          if (
            draftData[key].value !== undefined &&
            draftData[key].value !== "" &&
            draftData[key].value !== null
          ) {
            mergedFormData[key] = {
              ...mergedFormData[key],
              value: draftData[key].value,
              isTouched: draftData[key].isTouched || false,
            };
          }
        }
      }
    }

    // Set user/project specific values
    mergedFormData.authorizationno = {
      required: mergedFormData.authorizationno.required,
      value: user.company.qualificationNo,
    };
    mergedFormData.company = {
      required: mergedFormData.company.required,
      value: user.company.id,
    };
    mergedFormData.companyname = {
      required: mergedFormData.companyname.required,
      value: user.company.name,
    };
    mergedFormData.objectname = {
      required: mergedFormData.objectname.required,
      value: project.name,
    };
    mergedFormData.project = {
      required: mergedFormData.project.required,
      value: project.id,
    };
    mergedFormData.registrationno = {
      required: mergedFormData.registrationno.required,
      value: user.company.orgNo,
    };
    mergedFormData.responsibilityinsurance = {
      required: mergedFormData.responsibilityinsurance.required,
      value: user.company.responsibilityinsurance_text,
    };

    // Set persontiler if not admin
    if (!currentUserIsAdmin()) {
      mergedFormData.persontiler = {
        required: mergedFormData.persontiler.required,
        value: user.id,
      };
    }

    // Update state with merged data, then check workfrom date
    this.setState({ formData: mergedFormData }, () => {
      if (mergedFormData.workfrom?.value) {
        this.checkWorkfromDate(mergedFormData.workfrom.value);
      }
    });
  }

  getSuppliers() {
    LimeAPI.get("suppliers", this.supplierAbortController.signal)
      .then((response) => {
        const supplierData = response.data;
        const supplierArray = Array.isArray(supplierData)
          ? supplierData
          : Object.values(supplierData || {});
        this.setState({ supplier: supplierArray });

        const { formData } = this.state;
        const hasDraftSuppliers =
          formData.companysupplierfloor?.value &&
          formData.companysupplierfloor.value !== 0 &&
          formData.companysupplierfloor.value !== "" &&
          formData.companywallzone1supplier?.value &&
          formData.companywallzone1supplier.value !== 0 &&
          formData.companywallzone1supplier.value !== "" &&
          formData.companywallzone2supplier?.value &&
          formData.companywallzone2supplier.value !== 0 &&
          formData.companywallzone2supplier.value !== "";

        if (hasDraftSuppliers) {
          this.getSupplierSystems();
          return;
        }

        const companyData = this.props.user.company;
        const wallzone1supplier = supplierArray.find(
          (s: { suppliername: string }) =>
            companyData?.wallzone1supplier_text === s.suppliername,
        );
        const wallzone2supplier = supplierArray.find(
          (s: { suppliername: string }) =>
            companyData?.wallzone2supplier_text === s.suppliername,
        );
        const floorsupplier = supplierArray.find(
          (s: { suppliername: string }) =>
            companyData?.floorsupplier_text === s.suppliername,
        );

        if (!floorsupplier || !wallzone1supplier || !wallzone2supplier) {
          this.getSupplierSystems();
          return;
        }

        this.setState(
          (prevState: any) => ({
            formData: {
              ...prevState.formData,
              companysupplierfloor: {
                ...prevState.formData.companysupplierfloor,
                value: floorsupplier._id + "",
                isTouched: true,
              },
              companysupplierfloor_text: {
                ...prevState.formData.companysupplierfloor_text,
                value: floorsupplier.suppliername,
                isTouched: true,
              },
              companywallzone1supplier: {
                ...prevState.formData.companywallzone1supplier,
                value: wallzone1supplier._id + "",
                isTouched: true,
              },
              companywallzone1supplier_text: {
                ...prevState.formData.companywallzone1supplier_text,
                value: wallzone1supplier.suppliername,
                isTouched: true,
              },
              companywallzone2supplier: {
                ...prevState.formData.companywallzone2supplier,
                value: wallzone2supplier._id + "",
                isTouched: true,
              },
              companywallzone2supplier_text: {
                ...prevState.formData.companywallzone2supplier_text,
                value: wallzone2supplier.suppliername,
                isTouched: true,
              },
            },
          }),
          () => this.getSupplierSystems(),
        );
      })
      .catch(() => false);
  }

  getSupplierSystems() {
    const { formData } = this.state;
    const floorId = formData.companysupplierfloor?.value;
    const wall1Id = formData.companywallzone1supplier?.value;
    const wall2Id = formData.companywallzone2supplier?.value;

    if (floorId && floorId !== 0 && floorId !== "") {
      LimeAPI.get(
        `suppliers/${floorId}/system`,
        this.supplierAbortController.signal,
      )
        .then((response: any) =>
          this.setState({
            suppliersystemfloor: response.data?.floorsuppliers || {},
          }),
        )
        .catch(() => false);
    }

    if (wall1Id && wall1Id !== 0 && wall1Id !== "") {
      LimeAPI.get(
        `suppliers/${wall1Id}/system`,
        this.supplierAbortController.signal,
      )
        .then((response: any) =>
          this.setState({
            suppliersystemwallzone1: response.data?.wallsuppliers || {},
          }),
        )
        .catch(() => false);
    }

    if (wall2Id && wall2Id !== 0 && wall2Id !== "") {
      LimeAPI.get(
        `suppliers/${wall2Id}/system`,
        this.supplierAbortController.signal,
      )
        .then((response: any) =>
          this.setState({
            suppliersystemwallzone2: response.data?.wallsuppliers || {},
          }),
        )
        .catch(() => false);
    }
  }

  checkWorkfromDate(workfromValue: string, formData?: any) {
    if (!workfromValue) {
      return;
    }

    const selectedDate = new Date(workfromValue);
    const cutoffDate = new Date("2026-01-01");
    cutoffDate.setHours(0, 0, 0, 0);

    if (selectedDate < cutoffDate) {
      // Save current form data before redirecting
      const { project } = this.props;
      if (project && project.id) {
        // Use provided formData or current state
        const dataToSave = formData || this.state.formData;
        // Map v5 data to v4 format before saving
        const v4FormData = mapFormDataToV4(dataToSave);
        saveQualityDocumentDraft(v4FormData, project.id);
      }
      this.setState({ showLegacyRedirectAlert: true });
    }
  }

  onInputChange(event: any) {
    const { name } = event.target;
    const supplierInputs = [
      "companysupplierfloor",
      "companywallzone1supplier",
      "companywallzone2supplier",
    ];

    // Save state first
    this.saveState(event);

    // Check if workfrom date changed - check in next tick to ensure state is updated
    if (name === "workfrom") {
      const newValue = event.target.value;
      // Use requestAnimationFrame for more reliable timing than setTimeout
      requestAnimationFrame(() => {
        this.checkWorkfromDate(newValue);
      });
    }

    if (supplierInputs.includes(name)) {
      this.handleSupplierChange(event);
    }
  }

  handleSupplierChange(event: any) {
    const supplierId = event.target.value;
    const target = event.target.name
      .replace("supplier", "")
      .replace("company", "suppliersystem");
    const isFloorSystem = event.target.name.indexOf("floor") > -1;
    const fieldName = event.target.name + "_text";

    // Ensure supplier is an array before using .find()
    if (
      !Array.isArray(this.state.supplier) ||
      this.state.supplier.length === 0
    ) {
      return;
    }

    const selectedSupplier = this.state.supplier.find(
      (supplier: { _id: number }) => parseInt(supplierId, 10) === supplier._id,
    );

    if (!selectedSupplier) {
      return;
    }

    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        [fieldName]: {
          ...this.state.formData[fieldName],
          value: selectedSupplier.suppliername,
        },
      },
    });

    if (!this.state.formData.companysupplierfloor.value) {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          companysupplierfloor: {
            ...this.state.formData.companysupplierfloor,
            value: event.target.value,
            isTouched: true,
          },
          companysupplierfloor_text: {
            ...this.state.formData.companysupplierfloor_text,
            value: selectedSupplier.suppliername,
          },
        },
      });
    }

    if (!this.state.formData.companywallzone1supplier.value) {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          companywallzone1supplier: {
            ...this.state.formData.companywallzone1supplier,
            value: event.target.value,
            isTouched: true,
          },
          companywallzone1supplier_text: {
            ...this.state.formData.companywallzone1supplier_text,
            value: selectedSupplier.suppliername,
          },
        },
      });
    }

    if (!this.state.formData.companywallzone2supplier.value) {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          companywallzone2supplier: {
            ...this.state.formData.companywallzone2supplier,
            value: event.target.value,
            isTouched: true,
          },
          companywallzone2supplier_text: {
            ...this.state.formData.companywallzone2supplier_text,
            value: selectedSupplier.suppliername,
          },
        },
      });
    }

    LimeAPI.get(
      `suppliers/${supplierId}/system`,
      this.supplierAbortController.signal,
    )
      .then((response) =>
        this.setState({
          [target]:
            response.data[isFloorSystem ? "floorsuppliers" : "wallsuppliers"],
          formData: {
            ...this.state.formData,
            [target]: {
              ...this.state.formData[target],
              value: undefined,
            },
          },
        }),
      )
      .catch(() => false);
  }

  async onAddPicture(picture: any) {
    const pictures = [...this.state.formData.picture.value, picture];
    await this.savePictureState(pictures);
  }

  async removePicture(index: number) {
    const pictures: any = this.state.formData.picture.value;
    const filteredPictures = pictures.filter(
      (picture: any, pictureIndex: number) => pictureIndex !== index,
    );

    await this.savePictureState(filteredPictures);
  }

  async resizeImage(base64Str: string, maxWidth = 800, maxHeight = 450) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64Str;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = maxWidth;
        const MAX_HEIGHT = maxHeight;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx: any = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL());
      };
    });
  }

  async savePictureState(pictures: any) {
    pictures = await Promise.all(
      pictures.map((picture: string) => this.resizeImage(picture)),
    );

    this.setState(
      {
        formData: {
          ...this.state.formData,
          picture: {
            value: pictures,
            required: this.state.formData.picture.required,
          },
        },
      },
      () => this.setState({ isValid: validateForm(this.state) }),
    );
  }

  saveState(event: any) {
    const target = event.target;
    const value =
      event.target.localName === "ion-checkbox" ? target.checked : target.value;
    const name = target.name;

    const { formData }: any = this.state;
    const { project }: any = this.props;

    const relations: any = {};

    const inputName = target.getAttribute("name");
    const personFieldsLookup: any = {
      personsupervisor: "wetworkteamlead",
      persontiler: "tilername",
    };

    if (formData[name] && formData[name].relation) {
      for (const key in formData[name].relation) {
        if (formData[name].relation.hasOwnProperty(key)) {
          const relationName = formData[name].relation[key];
          relations[relationName] = {
            ...formData[relationName],
            required: false,
            value: false,
          };
        }
      }
    }

    if (inputName === "persontiler") {
      const personField = personFieldsLookup[inputName];
      const personMatch = project.persons.tilers.find(
        (person: any) => person.personId === target.value,
      );
      if (typeof personMatch !== "undefined") {
        formData[personField].value = personMatch.name;
      }
    }

    if (inputName === "personsupervisor") {
      const personField = personFieldsLookup[inputName];
      const personMatch = project.persons.supervisors.find(
        (person: any) => person.personId === target.value,
      );
      if (typeof personMatch !== "undefined") {
        formData[personField].value = personMatch.name;
      }
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          [name]: {
            value,
            isTouched: true,
            relation:
              formData[name] && formData[name].relation !== undefined
                ? formData[name].relation
                : undefined,
            required:
              formData[name] && formData[name].required !== undefined
                ? formData[name].required
                : undefined,
          },
          ...relations,
        },
      },
      () => {
        const notesConditionals =
          this.state.formData.floorfoundation.value !== "yes" ||
          this.state.formData.wallfoundation.value !== "yes" ||
          this.state.formData.floorslope.value !== true;

        const discrepanciesConditionals =
          this.state.formData.floorslopenotok?.value === true ||
          this.state.formData.otherleadthrough?.value === true;

        this.setState(
          {
            formData: {
              ...this.state.formData,
              otherinformation: {
                ...this.state.formData.otherinformation,
                required: notesConditionals,
              },
              discrepancies: {
                ...this.state.formData.discrepancies,
                required: discrepanciesConditionals,
              },
            },
          },
          () => this.setState({ isValid: validateForm(this.state) }),
        );
      },
    );

    // Debounce saving draft data to localStorage
    if (project && project.id) {
      if (this.saveDraftTimeout) {
        clearTimeout(this.saveDraftTimeout);
      }
      this.saveDraftTimeout = setTimeout(() => {
        saveQualityDocumentDraft(this.state.formData, project.id);
      }, 500);
    }
  }

  async createQualityDocument() {
    const { formData }: any = this.state;
    const data: any = {};

    loadingController
      .create({
        spinner: "crescent",
        message: "Sparar kvalitetsdokument...",
      })
      .then((controller) => controller.present())
      .catch();

    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        data[key] = formData[key].value;
      }
    }

    data.version = getCurrentVersion().version;

    const response = await LimeAPI.post(
      "qualitydocuments",
      data,
      this.abortController.signal,
    );
    loadingController.dismiss().catch();

    if (!response.success) {
      toastController
        .create({
          message: "Projektet kunde inte sparas, försök igen.",
          color: "dark",
          buttons: ["Ok"],
        })
        .then((toast) => toast.present())
        .catch();

      return;
    }

    await logEvent("createQualityDocument", {
      id: response.data._id,
      timestamp: response.data._timestamp,
    });

    this.props.addQualityDocument(response);

    const companyDefaultStates = {
      _embedded: {
        relation_company: {
          wallzone1supplier_text:
            this.state.formData.companywallzone1supplier_text.value,
          wallzone2supplier_text:
            this.state.formData.companywallzone2supplier_text.value,
          floorsupplier_text:
            this.state.formData.companysupplierfloor_text.value,
          responsibilityinsurance_text:
            this.state.formData.responsibilityinsurance.value,
        },
      },
    };

    this.props.setCompanyDefaultStates(companyDefaultStates);

    setProjectStatus("open", "open").catch(() => false);

    toastController
      .create({
        message: `Kvalitetsdokumentet "${response.data.objectname}" har lagts till.`,
        duration: 3000,
        color: "success",
      })
      .then((toast) => toast.present())
      .catch();

    // Clear draft data after successful creation
    clearQualityDocumentDraft();

    this.setState({ hasSubmitted: true });
  }

  componentWillUnmount() {
    // Clear any pending save timeout
    if (this.saveDraftTimeout) {
      clearTimeout(this.saveDraftTimeout);
    }
    // Clear draft data when component unmounts
    clearQualityDocumentDraft();
  }

  render() {
    if (this.state.hasSubmitted) {
      return <Redirect to={`/projects/${this.props.match.params.id}`} />;
    }

    return (
      <IonPage>
        <Header
          componentLeft="back"
          title="Kvalitetsdokument"
          componentRight="createQualityDocumentButton"
          componentRightHandler={this.createQualityDocument}
          componentSettings={{ isValid: this.state.isValid }}
        />
        <IonContent>
          <IonAlert
            isOpen={this.state.showLegacyRedirectAlert}
            header="Observera"
            message="För arbeten påbörjade innan 2026-01-01 används en tidigare version av mall för kvalitetsdokument."
            buttons={[
              {
                text: "OK",
                handler: () => {
                  this.props.history.push(
                    `/projects/${this.props.match.params.id}/qualitydocument/new-v4`,
                  );
                },
              },
            ]}
          />
          <form>
            <QualityDocumentsHeader hideStatus={true} />

            <IonGrid className="ion-padding-top ion-padding-bottom">
              <IonRow className="ion-justify-content-center">
                <IonCol sizeSm="10" sizeMd="8" sizeLg="6">
                  <QualityDocumentSectionOne
                    {...this.state}
                    inputChangeCallback={this.onInputChange}
                  />
                  <QualityDocumentSectionTwo
                    {...this.state}
                    inputChangeCallback={this.onInputChange}
                  />
                  <QualityDocumentSectionThree
                    {...this.state}
                    documentVersion={getCurrentVersion().version}
                    inputChangeCallback={this.onInputChange}
                    addPicture={this.onAddPicture}
                    removePicture={this.removePicture}
                  />
                  <QualityDocumentSectionFour
                    {...this.state}
                    inputChangeCallback={this.onInputChange}
                  />
                  <QualityDocumentSectionFive
                    {...this.state}
                    inputChangeCallback={this.onInputChange}
                  />

                  <IonButton
                    expand="block"
                    onClick={() => this.createQualityDocument()}
                    disabled={!this.state.isValid}
                    color={this.state.isValid ? "success" : "medium"}
                  >
                    Skapa kvalitetsdokument
                  </IonButton>
                  {!this.state.isValid && (
                    <p className="form-description font-size-xs">
                      För att kunna skapa kvalitetsdokumentet behöver alla
                      obligatoriska fält vara ifyllda.
                    </p>
                  )}
                </IonCol>
              </IonRow>
            </IonGrid>
          </form>
        </IonContent>
      </IonPage>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    project: state.currentProject,
    user: state.user,
  };
};

const mapDispatchToProps = {
  setCurrentProject: (project: any) =>
    actions.currentProject.setCurrentProject(project),
  addQualityDocument: (document: QualityDocumentsInterface) =>
    actions.qualityDocuments.addQualityDocument(document),
  setCompanyDefaultStates: (user: APIUserInterface) =>
    actions.user.setCompanyDefaultStates(user),
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withIonLifeCycle(PageNewQualityDocument)),
);

// const PageWithLifeCycle = withIonLifeCycle(PageNewQualityDocument);
// const ConnectedPage = connect(mapStateToProps, mapDispatchToProps)(PageWithLifeCycle);
// const PageWithRouter = withRouter(ConnectedPage);

// export default PageWithRouter;
